// library imports
import { Flex, Select } from "antd";

export default function SiteSelection(props) {
  const { siteSelected, setSiteSelected, siteList, loading } = props;

  return (
    <Flex align="center">
      <p className="mr-2">Site:</p>
      <Select
        style={{ minWidth: "calc(100vw - 54px)", textAlign: "left" }}
        loading={loading}
        showSearch
        value={siteSelected}
        options={siteList}
        optionFilterProp="label"
        labelRender={(value) => <>{value.label}</>}
        onChange={(value) => {
          setSiteSelected(value);
        }}
      />
    </Flex>
  );
}
